/* 🤖 this file was generated by script */
export const wiconBracketsPlus = {
  name: 'brackets_plus',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.57 20a2.29 2.29 0 002.29-2.29v-4.57L22 12l-1.14-1.14V6.29A2.29 2.29 0 0018.57 4M5.43 4a2.29 2.29 0 00-2.29 2.29v4.57L2 12l1.14 1.14v4.57A2.29 2.29 0 005.43 20M12 8v8m-4-4h8"/></svg>`,
};
